function ensureNumericOrNull (obj, property) {
  const val = obj[property]
  let nan = (val === null || val === undefined || val === '')

  if (!nan) {
    nan = isNaN(nan)
  }

  if (nan) {
    delete obj[property]
  } else {
    obj[property] = Number(val)
  }

  return obj[property]
}

export { ensureNumericOrNull }
